import SnackbarMount, { SnackbarMountProps } from "./SnackbarMount";

function SnackbarOnWarning({ duration, ...props }: Omit<SnackbarMountProps, "variant">) {
  return (
    <SnackbarMount
      {...props}
      duration={duration}
      variant="warning"
    />
  );
}

export default SnackbarOnWarning;
